'use strict'

export default {
  data() {
    return {}
  },
  mounted() {
    setTimeout(() => {
      console.log('Redirecting to', this.$props.redirectUrl)
      window.location.href = this.$props.redirectUrl
    }, 5000)
  },
  props: [
    'redirectUrl'
  ]
}


// WEBPACK FOOTER //
// ./src/components/Redirect/Redirect.js